const Tools = {
  getQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  },
  tongji: function (action, obj, type, pvObj) {
    const dispose = {
      biz: 'cf', // 所属业务线
      type: type && type === 1 ? 'show' : 'click', // 事件类型
      action, // 业务事件标识
      ctime: new Date().getTime(), // 客户端触发时间
      area: 'top', // 模块区域标识
      element: 'details', // 页面元素标识
      evextends: JSON.stringify(obj),
      ...pvObj
    }
    window.trackCustomEvent && window.trackCustomEvent('auto_common_event', dispose)
  },
}
export default Tools



// WEBPACK FOOTER //
// ./src/tools/tools.js